import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";

import { useSession } from "../../api/hooks.js";

/**
 * A screen that needs a session, and what happens when there is not one.
 *
 * The bounce is the same whether the operator arrived without a session or lost one
 * mid-task: any 401 retires the bearer in the client, the session store tells its
 * watchers, and this sends him to sign in carrying where he was. Signing in returns
 * him there rather than to a landing page, so an expired session costs a password and
 * not a place.
 */
export function RequireSession({ children }: { children: ReactNode }) {
  const session = useSession();
  const location = useLocation();

  if (!session) {
    const here = `${location.pathname}${location.search}`;
    return (
      <Navigate replace to={`/sign-in?next=${encodeURIComponent(here)}`} />
    );
  }
  return <>{children}</>;
}
